export default function getCardPricePromotion(promotions) {
  return promotions?.find(i => i.promotion.display_slash_in_web_service_card) || null
}
